import React, {
  FunctionComponent,
} from 'react';

import {
  ActionsDropdownTransitions,
  ActionsOpenDirections,
  UserDevices,
} from '@components/library/dropdown/index';
import BaseDropdown from '../BaseDropdown';
import styleClassNames from './styles.module.scss';

interface ActionsDropdownProps {
  anchorElement?: JSX.Element;
  className?: string;
  closeCallback?: () => void;
  closeDropdown?: boolean;
  dropdownTransition?: ActionsDropdownTransitions;
  openDirection?: ActionsOpenDirections;
  openOnClick?: boolean;
  openOnHover?: boolean;
  userDevice?: UserDevices;
}

export const ActionsDropdown: FunctionComponent<ActionsDropdownProps> = (
  props
) => {
  const {
    anchorElement,
    dropdownTransition = ActionsDropdownTransitions.FadeInTranslate,
  } = props;
  const defaultAnchorElement = <span className={`bff-ellipsis ${styleClassNames.ellipsis}`} />;

  const baseProps = {
    ...props,
    anchorElement: anchorElement || defaultAnchorElement,
    dropdownTransition,
    styleClassNames,
    variantName: 'actions',
  };

  return <BaseDropdown {...baseProps} />;
};
